import React from "react";
import { Helmet } from "react-helmet-async";
import { appUrl } from "../../../constants/url-constants";
import { useLocation } from "react-router";
import parseLocationSearchParams from "../../../utils/helpers/parse-location-search-params";
// import { OG_IMAGE_TYPES, OGImage } from "../og-image";

const getTitle = (pageNumber) => {
    if (pageNumber === 1) return "Used Car Valuation : Customer Reviews | CARS24";
    return `Used Car Valuation : Customer Reviews- Page ${pageNumber} | CARS24`;
};

const getDescription = (pageNumber) => {
    if (pageNumber === 1) return "Explore genuine customer testimonials about CARS24's used car valuation service. Discover how our transparent and efficient process has helped thousands get the best value for their vehicles.";
    return `Page ${pageNumber} of CARS24 Used Car Valuation Customer Reviews. Trust CARS24 for expert inspection, instant payment, and a smooth, reliable experience.`;
};

const MetaTagsReviews = () => {
    const location = useLocation();
    const params = location.search.toLowerCase();
    const baseUrl = appUrl();
    const url = `${location.pathname.toLowerCase()}${params}`;
    const { page } = parseLocationSearchParams(params) || {};
    const pageNumber = Number(page) || 1;

    const metaTitle = getTitle(pageNumber);
    const metaDescription = getDescription(pageNumber);
    const metaKeywords = "";

    const commonSchemaContent = {
        "@context": "https://schema.org/",
        "@id": "https://www.cars24.com/",
        "url": "https://www.cars24.com/",
        "name": "CARS24"
    };

    const script = [
        {
            type: "application/ld+json",
            innerHTML: JSON.stringify({
                "@type": "WebPage",
                ...commonSchemaContent
            })
        },
        {
            type: "application/ld+json",
            innerHTML: JSON.stringify({
                "@type": "Website",
                ...commonSchemaContent
            })
        }
    ];

    return (
        <React.Fragment>
            <Helmet script={script}>
                <title>{metaTitle}</title>
                <meta name="title" content={metaTitle} />
                <meta name="description" content={metaDescription} />
                <meta name="keywords" content={metaKeywords} />
                <meta property="og:title" content={metaTitle} />
                <meta property="og:description" content={metaDescription} />
                <meta property="og:url" content={`${baseUrl}`} />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="CARS24" />
                <meta name="ROBOTS" content="INDEX,FOLLOW" />
                <link href={`${baseUrl}${url}`} rel="canonical" />
            </Helmet>
            {/* <OGImage type={OG_IMAGE_TYPES.buycar} /> */}
        </React.Fragment>
    );
};

export default MetaTagsReviews;
